<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="introduce">
      <p class="sub_title">
        用户痛点
      </p>
      <div class="content_A">
        <div class="pain">
          站在攻击者的视角，网络攻击一般是从资产情报收集开始的，单位开放了各种服务，这些服务同时也暴露了单位的网络资产，给攻击者提供了重要的资产情报。同时资产管理也面临以下问题：
        </div>
        <div
          v-for="fwjs in introduceList"
          :key="fwjs.id"
          class="content_list"
        >
          <div class="pain">
            <img
              v-if="fwjs.imgUrl"
              :src="fwjs.imgUrl"
              alt=""
            >
            <div class="point_tit">
              <div class="point" /> {{ fwjs.content }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        产品理念
      </p>
      <div class="content_A">
        <div class="content_list">
          网络空间资产风险感知系统以前置防御思维模式为指导，做好资产攻击面管理的目标，帮助用户可以对暴露面资产和攻击面进行科学高效的管理，从攻击者视角审视单位信息化资产可能存在的风险点和脆弱性。
        </div>
      </div>
      <div class="content_A center_img">
        <img
          src="@/assets/production/pic5.png"
          alt=""
        >
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        产品功能
      </p>
      <div class="content_A">
        <div class="content_list">
          <p class="text">
            资产全面画像：
          </p>
          <div class="text">
            自动识别资产，基于海量的资产指纹，全面识别和分类网络资产，包括服务器、数据库、应用程序等。
          </div>
        </div>
      </div>
      <div class="content_A center_img1">
        <img
          src="@/assets/production/pic6.png"
          alt=""
        >
      </div>
      <div class="content_A  text">
        资产数量，统计网络资产的数量，包括总数量和分类数量，以及各资产类型的使用情况和分布情况。
        <!-- <img src="@/assets/production/pic7.png" alt="" /> -->
      </div>
      <div class="content_A center_img1">
        <img
          src="@/assets/production/pic7.png"
          alt=""
        >
      </div>
      <div
        v-for="fun in functions"
        :key="fun.id"
      >
        <div class="content_A ">
          <p class="text">
            {{ fun.title }}
          </p>
          <div class="text">
            {{ fun.text1 }}
          </div>
          <div class="text">
            {{ fun.text2 }}
          </div>
          <div class="text">
            {{ fun.text3 }}
          </div>
        </div>
        <div class="content_A center_img1">
          <img
            :src="fun.imgUrl"
            alt=""
          >
        </div>
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        用户价值
      </p>
      <div
        v-for="yhjz in UserLists"
        :key="yhjz.id"
        class="content_A center"
      >
        <div class="center_img1">
          <img
            :src="yhjz.imgUrl"
            alt=""
          >
        </div>
        <div class="content_list">
          <p class="text">
            {{ yhjz.title }}
          </p>
          {{ yhjz.content }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Risk',
  components: {
    banner
  },
  data() {
    return {
      title: '灵创网络空间资产风险感知系统',
      content: '',
      introduceList: [
        {
          id: 2,
          imgUrl: require('@/assets/production/pic1.png'),
          content:
            '全网资产总数，资产存活数量等问题梳理不清晰，导致安全防护存在盲区；'
        },
        {
          id: 3,
          imgUrl: require('@/assets/production/pic2.png'),
          content:
            '数字化与信息化的发展，大量项目的叠加，全量资产无法动态更新，资产更新信息滞后。'
        },
        {
          id: 4,
          imgUrl: require('@/assets/production/pic3.png'),
          content:
            '资产的责任人和权属部门责任可能会变化，缺乏有效手段高效、实时管控此类变化；'
        },
        {
          id: 5,
          imgUrl: require('@/assets/production/pic4.png'),

          content:
            '资产责任人不积极处置漏洞，漏洞修复情况安全人员无法验证，存在漏洞遗留疏漏的风险。'
        }
      ],

      UserLists: [
        {
          id: 1,
          imgUrl: require('@/assets/production/pic11.png'),
          title: '全面资产梳理，关联分析运营',
          content:
            '帮助用户理清内部资产数量复杂问题，及时了解用户本身的核心资产，过智能化分类管理和关联分析，增强用户内部资产统一管理及自动识别资产的能力避免用户内部出现资产孤岛。'
        },
        {
          id: 2,
          imgUrl: require('@/assets/production/pic12.png'),
          title: '发现风险资产，快速定位响应',
          content:
            '帮助用户绘制资产风险暴漏对面，实现资产风险数据的综合展现，明确每个资产存在的安全风险。同时对资产进行梳理归档，整理资产台账。精细化业务信息登记管理，并分配负责人。遇到紧急事件，可快点定位业务、机房以及对应负责人，大大提高风险处置效率。'
        },
        {
          id: 3,
          imgUrl: require('@/assets/production/pic13.png'),
          title: '违规资产告警，持续安全监测',
          content:
            '周期性对用户资产进行核查，将前后资产变化情况进行对比，更新资产监测范围，对资产变化进行动态监测，精准掌控自有资产基本情况和暴露面分布。'
        }
      ],
      functions: [
        {
          id: 1,
          imgUrl: require('@/assets/production/pic8.png'),
          title: '高效资产管理：',
          text1: '资产卡片，定义重要资产，便于识别和管理；',
          text2: '风险特征管理，识别和管理可能引发风险的资产特性；',
          text3: '资产决策支撑，结合数据分析，提供有效的资产管理决策；'
        },
        {
          id: 2,
          imgUrl: require('@/assets/production/pic9.png'),
          title: '深入攻击面分析：',
          text1: '对识别到的资产进行攻击面分析，评估资产的脆弱性和风险等级；',
          text2: '对资产的漏洞、弱口令进行监控和预警，并提供修复建议；',
          text3: '根据资产的攻击面和风险等级，制定相应的安全策略和防护措施；'
        },
        {
          id: 3,
          imgUrl: require('@/assets/production/pic10.png'),
          title: '实时风险监测：',
          text1: '对网络空间资产进行实时监控，发现异常情况；',
          text2: '根据风险等级，触发预警机制，提醒相关人员；',
          text3: '提供风险处置方案，帮助用户快速应对风险；'
        }
      ]
    }
  }
}
</script>

<style scoped>
@import '../../styles/utils.scss';
.pain img {
  width: 50px;
  display: block;
  height: 50px;
}
.pain{
  margin-bottom: 10px;
}
.point_tit{
  display: flex;
  align-items: center;
}
.pain .point{
 float: left;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 10px;
  background-color: #333;
}
.center_img img {
  width: 100%;
}
.center_img1 {
  display: flex;
  justify-content: center;
}

/* .content_list {
  text-align: center;
} */
.text {
  text-align: center;
}
.center {
  /* display: flex; */
}
</style>
